import type { SectionItem } from '../catalog/types';

type SectionGroup = {
  title: string;
  items: SectionItem[];
  exclusiveLabel?: string;
  exclusiveItems?: SectionItem[];
};

type SectionNavProps = {
  groups: SectionGroup[];
};

export function SectionNav({ groups }: SectionNavProps) {
  return (
    <nav className="space-y-6 text-sm">
      {groups.map((group) => (
        <div key={group.title} className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
            {group.title}
          </p>
          <ul className="space-y-1">
            {group.items.map((item) => (
              <li key={item.id}>
                <a
                  className="block rounded-md px-2 py-1 text-foreground/80 transition hover:bg-muted/50 hover:text-foreground"
                  href={`#${item.id}`}
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
          {group.exclusiveItems && group.exclusiveLabel && (
            <>
              <div className="flex items-center gap-2 pt-2">
                <div className="h-px flex-1 bg-border" />
                <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground">
                  {group.exclusiveLabel}
                </p>
                <div className="h-px flex-1 bg-border" />
              </div>
              <ul className="space-y-1">
                {group.exclusiveItems.map((item) => (
                  <li key={item.id}>
                    <a
                      className="block rounded-md px-2 py-1 text-foreground/80 transition hover:bg-muted/50 hover:text-foreground"
                      href={`#${item.id}`}
                    >
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      ))}
    </nav>
  );
}
